import { render, staticRenderFns } from "./Detailinfo.vue?vue&type=template&id=76e1feea"
import script from "./Detailinfo.vue?vue&type=script&lang=js"
export * from "./Detailinfo.vue?vue&type=script&lang=js"
import style0 from "./Detailinfo.vue?vue&type=style&index=0&id=76e1feea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports